import * as yup from 'yup'
import { ReviewType } from '../ReviewsWizard/types'
import { ObjectSchema } from 'yup'
import { Reviewer } from './utils'
import { useCallback } from 'react'

export interface ReviewConfigInput {
  reviewers: Reviewer[]
  approvers: Reviewer[]
  viewers: Reviewer[]
}

const feedbackValidationSchema = yup.object().shape(
  {
    reviewers: yup.array().when('approvers', ([approvers], schema) => {
      return (approvers || []).length === 0
        ? schema.required('You must add at least one approver or reviewer').min(1)
        : schema
    }),
    approvers: yup.array().when('reviewers', ([reviewers], schema) => {
      return (reviewers || []).length === 0
        ? schema.required('You must add at least one approver or reviewer').min(1)
        : schema
    }),
  },
  [['approvers', 'reviewers']],
)

const approvalValidationSchema = yup.object({
  approvers: yup.array().required().min(1),
})

const readReceiptValidationSchema = yup.object().shape({
  viewers: yup.array().required().min(1),
})

const validationSchemas: Record<ReviewType, ObjectSchema<object>> = {
  [ReviewType.APPROVAL]: approvalValidationSchema,
  [ReviewType.FEEDBACK]: feedbackValidationSchema,
  [ReviewType.SUGGESTIONS]: yup.object({}),
  [ReviewType.READ_RECEIPTS]: readReceiptValidationSchema,
}

export const useReviewValidator = (reviewType: ReviewType) =>
  useCallback(
    (config: Partial<ReviewConfigInput>) => {
      const schema = validationSchemas[reviewType] || yup.object({})

      return schema.validateSync(config)
    },
    [reviewType],
  )
